export default {
  getRules: {
    method: "get",
    url: "/rule-engine/api/v1/rules",
  },
  getVariables: {
    method: "get",
    url: "/rule-engine/api/v1/rules/:ruleCode",
  },
  getRuleConfigByCode: {
    method: "get",
    url: "/rule-engine/api/v1/rules/:ruleCode/configs/:configCode",
  },
  getRuleConfig: {
    method: "get",
    url: "/rule-engine/api/v1/rules/:ruleCode/configs",
  },
  postRuleConfig: {
    method: "post",
    url: "/rule-engine/api/v1/rules/:ruleCode/configs",
  },
  putRuleConfigByCode: {
    method: "put",
    url: "/rule-engine/api/v1/rules/:ruleCode/configs/:configCode",
  },
};
